// extracted by mini-css-extract-plugin
export var ignore = "_6z-1";
export var mapping = "_6z-0";
export var range = "_6z-4";
export var savings = "_6z-3";
export var settings = "_6z-2";